import { BaSeLoading, BaSeParagraph, BaSeSmall1 } from '@base/react';
import React from 'react';
import { cpfMask } from '../../../../../../utils/formatters/cpfMask';
import { phoneMask } from '../../../../../../utils/formatters/phoneMask';

function PersonalItems({ id, loading ,item}) {

  if (loading) {
    return (
      <BaSeLoading
        backgroundColor="#fff"
        description=""
        lightMode="default"
        shadowLevel={0}
        spinnerColor=""
        spinnerSize={24}
        text="Carregando…"
        textColor=""
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <BaSeParagraph>
        <BaSeParagraph>
          <BaSeSmall1>
            <strong>Turma:</strong>
            {` ${item.classNameLinked ?? ''}`}
          </BaSeSmall1>
        </BaSeParagraph>
        <BaSeSmall1>
          <strong>CPF:</strong>
          {` ${cpfMask(item.cpf ?? '')}`}
        </BaSeSmall1>
      </BaSeParagraph>
      <BaSeParagraph>
        <BaSeSmall1>
          <strong>Telefone:</strong>
          {` ${phoneMask(item.phone ?? '')}`}
        </BaSeSmall1>
      </BaSeParagraph>
      <BaSeParagraph>
        <BaSeSmall1>
          <strong>E-mail:</strong>
          {` ${item.email}`}
        </BaSeSmall1>
      </BaSeParagraph>
      <BaSeParagraph>
        <BaSeSmall1>
          <strong>UF:</strong>
          {` ${item.uf}`}
        </BaSeSmall1>
      </BaSeParagraph>
    </div>
  );
}

export default PersonalItems;
